import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { environment } from '../environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';

import { HeaderComponent } from './components/partials/header/header.component';
import { FooterComponent } from './components/partials/footer/footer.component'
// Partial Components
import { HeroComponent } from './components/partials/hero/hero.component';
import { AboutComponent } from './components/partials/about/about.component';
import { BrandSliderComponent } from './components/partials/brand-slider/brand-slider.component';
import { OurGalleryComponent } from './components/partials/our-gallery/our-gallery.component';
import { OurFeaturesComponent } from './components/partials/our-features/our-features.component';
import { TestimonialComponent } from './components/partials/testimonial/testimonial.component';
import { OurServicesComponent } from './components/partials/our-services/our-services.component';
import { OurProcessComponent } from './components/partials/our-process/our-process.component';
import { RecentProjectComponent } from './components/partials/recent-project/recent-project.component';
import { GetInTouchComponent } from './components/partials/get-in-touch/get-in-touch.component';
import { WhyChooseUsComponent } from './components/partials/why-choose-us/why-choose-us.component';
import { CounterComponent } from './components/partials/counter/counter.component';
import { CustomerServiceStripComponent } from './components/partials/customer-service-strip/customer-service-strip.component';
import { BlogAreaComponent } from './components/partials/blog-area/blog-area.component';
// Our Portfolio
import { AnimationComponent } from './components/portfolio/animation/animation.component';
import { EcommerceComponent } from './components/portfolio/ecommerce/ecommerce.component';
import { LaravelComponent } from './components/portfolio/laravel/laravel.component';
import { LogoDesignsComponent } from './components/portfolio/logo-designs/logo-designs.component';
import { MobileAppComponent } from './components/portfolio/mobile-app/mobile-app.component';
import { NextJsComponent } from './components/portfolio/next-js/next-js.component';
import { ReactJsComponent } from './components/portfolio/react-js/react-js.component';
import { WebDesignComponent } from './components/portfolio/web-design/web-design.component';
import { WordpressComponent } from './components/portfolio/wordpress/wordpress.component';
// Our Services
import { AndroidDevelopmentComponent } from './components/services/android-development/android-development.component';
import { IosDevelopmentComponent } from './components/services/ios-development/ios-development.component';
import { MobileDevelopmentComponent } from './components/services/mobile-development/mobile-development.component';
import { SeoServicesComponent } from './components/services/seo-services/seo-services.component';
import { SoftwareDevelopmentComponent } from './components/services/software-development/software-development.component';
import { UxUiDesignComponent } from './components/services/ux-ui-design/ux-ui-design.component';
import { WebsiteDevelopmentComponent } from './components/services/website-development/website-development.component';
import { AppDevelopmentComponent } from './components/services/app-development/app-development.component';
import { AiAssistedIntegrationsComponent } from './components/services/ai-assisted-integrations/ai-assisted-integrations.component';
import { MaintenanceAndUpdatesComponent } from './components/services/maintenance-and-updates/maintenance-and-updates.component';
import { AnalysisComponent } from './components/services/analysis/analysis.component';
import { TestingAndReviewComponent } from './components/services/testing-and-review/testing-and-review.component';
import { DeploymentComponent } from './components/services/deployment/deployment.component';
import { LogoDesignComponent } from './components/services/logo-design/logo-design.component';
// SideBar
import { BlogSidebarComponent } from './components/partials/blog-sidebar/blog-sidebar.component';
import { ServiceSidebarComponent } from './components/partials/service-sidebar/service-sidebar.component';
// Pages
import { HomeComponent } from './components/pages/home/home.component';
import { AboutUsComponent } from './components/pages/about-us/about-us.component';
import { CareersComponent } from './components/pages/careers/careers.component';
import { CareerDetailsComponent } from './components/pages/career-details/career-details.component';
import { ContactUsComponent } from './components/pages/contact-us/contact-us.component';
import { LatesNewsComponent } from './components/pages/lates-news/lates-news.component';
import { BlogDetailsComponent } from './components/pages/blog-details/blog-details.component';
import { OurProjectsComponent } from './components/pages/our-projects/our-projects.component';
import { ProjectDetailsComponent } from './components/pages/project-details/project-details.component';
import { ServicesComponent } from './components/pages/services/services.component';
import { ServiceDetailsComponent } from './components/pages/service-details/service-details.component';
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './components/pages/terms-of-service/terms-of-service.component';
// Error Page
import { ErrorComponent } from './components/pages/error/error.component';


@NgModule({
    declarations: [
        AppComponent,
        SafeHtmlPipe,
        HeaderComponent,
        HeroComponent,
        AboutComponent,
        OurServicesComponent,
        BrandSliderComponent,
        TestimonialComponent,
        OurGalleryComponent,
        OurFeaturesComponent,
        OurProcessComponent,
        RecentProjectComponent,
        GetInTouchComponent,
        WhyChooseUsComponent,
        CounterComponent,
        BlogAreaComponent,
        CustomerServiceStripComponent,
        FooterComponent,

        ServiceSidebarComponent,
        BlogSidebarComponent,

        AndroidDevelopmentComponent,
        AiAssistedIntegrationsComponent,
        IosDevelopmentComponent,
        MobileDevelopmentComponent,
        SeoServicesComponent,
        SoftwareDevelopmentComponent,
        UxUiDesignComponent,
        WebsiteDevelopmentComponent,
        AppDevelopmentComponent,
        MaintenanceAndUpdatesComponent,
        AnalysisComponent,
        TestingAndReviewComponent,
        DeploymentComponent,
        LogoDesignComponent,

        AnimationComponent,
        EcommerceComponent,
        LaravelComponent,
        LogoDesignsComponent,
        MobileAppComponent,
        NextJsComponent,
        ReactJsComponent,
        WebDesignComponent,
        WordpressComponent,

        HomeComponent,
        AboutUsComponent,
        CareersComponent,
        CareerDetailsComponent,
        ContactUsComponent,
        LatesNewsComponent,
        BlogDetailsComponent,
        OurProjectsComponent,
        ProjectDetailsComponent,
        ServicesComponent,
        ServiceDetailsComponent,
        PrivacyPolicyComponent,
        TermsOfServiceComponent,
        ErrorComponent

    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        RecaptchaV3Module,
        RouterModule,
        AppRoutingModule
    ],
    providers: [
        {
            provide: RECAPTCHA_V3_SITE_KEY,
            useValue: environment.recaptcha.siteKey
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
